import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { safeReturnPage } from 'app/modules/shared/utils/third-party-data';
import { environment } from 'environments/environment';

// sessionStorage: the page the user was on when the sign-in started, so that the sign-in brings them back to it. Only the
// path and the query of a page of this app, no token; it belongs to this tab.
export const RETURN_PAGE_KEY = 'returnPage';

/** The page to come back to after the sign-in, or null. Leaves it in place. */
export function peekReturnPage(): string | null {
    try {
        return safeReturnPage(sessionStorage.getItem(RETURN_PAGE_KEY));
    } catch {
        return null;
    }
}

export const partnerId = () => {
    const subDomain = window.location.hostname.split('.')[0];
    if (subDomain === 'localhost' || subDomain === 'adele') {
        return 'AP';
    } else if (subDomain === 'juh') {
        return 'JUH';
    }
    return 'AP';
};

export const authConfig: OpenIdConfiguration = {
    authority: environment.ssoUrl,
    redirectUrl: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/',
    // The library navigates here once it has processed the answer of the sign-in; without this it is the start address,
    // which redirects to the start page and would win over the page the user was on.
    postLoginRoute: peekReturnPage() ?? '/',
    clientId: 'alma-web-app',
    scope: 'openid profile email',
    responseType: 'code',
    customParamsAuthRequest: {
        brand_id: partnerId(),
    },
    // silentRenew: true,
    // useRefreshToken: true,
    // renewTimeBeforeTokenExpiresInSeconds: 30,
    // triggerRefreshWhenIdTokenExpired: false,
    logLevel: environment.oidcLogLevel,
    // secureRoutes: [
    //     'https://sso.dev.almaphil.de',
    //     'https://sso.test.almaphil.de',
    //     'https://sso.almaphil.de',
    // ],
};
